/* src/modules/create_tutor/cards/AddTutorsSuccessCard/styles.js */

export default theme => ({
  paper: {
    paddingBottom: theme.spacing.unit * 3,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  button: {
    marginRight: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 3,
  },
  label: {
    marginLeft: theme.spacing.unit * 3,
  },
  greenText: {
    color: 'green',
  },
});



// WEBPACK FOOTER //
// ./src/modules/create_tutor/cards/AddTutorsSuccessCard/styles.js